import { restApi } from '../../services/Api'
import { createBasicLoopbackRepository as createRepository } from 'elentari'
import { query, paginate } from '../../lib/loopback'

const logsRepository = createRepository({
  path: 'logs',
  restApi,
  queryTransform: {
    consulta: query.ilikeWithoutSplit('consulta'),
    dataInicio: query.gte('dataInicio'),
    dataFim: query.lte('dataFim'),
    ...paginate
  }
})

export default logsRepository
